module.exports = __webpack_public_path__ + "static/media/brand.d4c5a458.svg";